module.exports = __webpack_public_path__ + "img/11.2cd68c6b.png";